import { render, staticRenderFns } from "./AdvisoryReview2.vue?vue&type=template&id=50c839c4&scoped=true"
import script from "./AdvisoryReview2.vue?vue&type=script&lang=js"
export * from "./AdvisoryReview2.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryReview2.vue?vue&type=style&index=0&id=50c839c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c839c4",
  null
  
)

export default component.exports